<template>
    <div class="dataTable">
        <LoaderComponent v-if="isLoading && maintenances.length === 0" />
        <div v-else class="datatable-container">
            <DataTable :isLoading="isLoading" :not-sticky="true" :tableData="maintenances" :tableHeader="tableHeader" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { store } from '@/plugins/store';
import DataTable from '@/components/ui-components/DataTable.vue';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import { Operation } from '@/models/Operation';
import { EquipementAction } from '@/modules/Equipements/store/actions-types';

export default defineComponent({
    name: 'MaintenancesTab',
    components: { LoaderComponent, DataTable },
    props: {
        phaseId: {
            type: Number,
            required: true,
        },
    },
    beforeMount() {
        store.dispatch(`equipementState/${EquipementAction.GET_OPERATION_MAINTENANCE}`, this.phaseId);
    },
    computed: {
        tableHeader() {
            return store.getters['equipementState/getMaintenancesHeaders'];
        },
        isLoading(): boolean {
            return store.getters['equipementState/getMaintenancesLoading'];
        },
        maintenances(): [] {
            return store.getters['equipementState/getMaintenancesData'].map((c: Operation) => {
                return {
                    operation: c.libelle,
                    periodicite: c.periodicite,
                };
            });
        },
    },
});
</script>
<style scoped></style>
